import {Col, Row} from "antd";
import React from "react";
import {CourierWalletSettings} from "./courierWalletSettings/CourierWalletSettings";
import {CourierWallet} from "./courierWallet/CourierWallet";

export const CourierWalletTab = ({
    courier,
    courierLoading = true,
    isTabActive = false,
    reloadCourier = () => {}
}) => {
    return (
        <div>
            <Row gutter={[20, 20]}>
                {/* Wallet hiç yoksa CourierWalletSettings göster */}
                {!courier?.isWalletActive && !courierLoading && (
                    <Col xs={24} sm={24} md={12} lg={8} xl={8} span={5}>
                        <CourierWalletSettings
                            courier={courier}
                            courierLoading={courierLoading}
                            reloadCourier={reloadCourier}
                        />
                    </Col>
                )}
                {/* CourierWallet bileşeni kendi içinde wallet kontrolü yapacak */}
                <Col xs={24} sm={24} md={24} lg={24} xl={24} span={24}>
                    <CourierWallet
                        courier={courier}
                        courierLoading={courierLoading}
                        canRender={isTabActive}
                        reloadCourier={reloadCourier}
                    />
                </Col>
            </Row>
        </div>
    );
};
